<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="heart"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.3015 3.61638C21.1691 2.53879 19.6029 2 17.6029 2C16.5735 2 15.4853 2.34483 14.3382 3.03448C13.5441 3.49425 12.7647 4.08333 12 4.80172C11.2353 4.08333 10.4559 3.49425 9.66177 3.03448C8.51471 2.34483 7.42647 2 6.39706 2C4.39706 2 2.83088 2.53879 1.69853 3.61638C0.566176 4.69397 0 6.18103 0 8.07759C0 9.39943 0.5 10.7644 1.5 12.1724C2.02941 12.9195 2.54412 13.5086 3.04412 13.9397L11.2941 21.7414C11.5 21.9138 11.7353 22 12 22C12.2647 22 12.5 21.9138 12.7059 21.7414L20.9559 13.9397C21.5735 13.3649 22.1176 12.7328 22.5882 12.0431C23.5294 10.6925 24 9.37069 24 8.07759C24 6.18103 23.4338 4.69397 22.3015 3.61638ZM20.9474 10.8996C20.5496 11.4824 20.1026 12.0017 19.5935 12.4755L12 19.6563L4.4183 12.4865C3.98425 12.1095 3.57373 11.6397 3.13185 11.0161C2.35638 9.9242 2 8.95132 2 8.07759C2 6.70199 2.36518 5.74285 3.07727 5.0652C3.80959 4.3683 4.88017 4 6.39706 4C7.03544 4 7.77711 4.23501 8.63121 4.74853C9.31655 5.14563 9.97398 5.64253 10.6306 6.25939L12 7.54584L13.3694 6.25939C14.026 5.64253 14.6835 5.14563 15.3403 4.76532C16.2229 4.23501 16.9646 4 17.6029 4C19.1198 4 20.1904 4.3683 20.9227 5.0652C21.6348 5.74285 22 6.70199 22 8.07759C22 8.93262 21.6677 9.86589 20.9474 10.8996Z"
      fill="#4B4C52"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'FavoritesIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
